import { useParams, useNavigate } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';
import { useEffect, useState } from 'react';
import { Stack, Text, PrimaryButton, Spinner, SpinnerSize, Icon, ImageFit, Image } from '@fluentui/react';
import { fetchItemById, getTokenAndListInfo, useSmartBack, japaneseDateConverter, phoneNumFormat } from '../../utils/item-helper';
import { common, formatMessage } from "../../messages/common-items";
import { listname } from '../../constants/global-values';
import { personalInformation } from '../../messages/personal-Information';

export default function AdminDetailViewPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { instance } = useMsal();
  const [item, setItem] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const goBack = useSmartBack("/");
  const { Labels: Lbl_Common, SuccessMessages: Success_Common, ErrorMessages: Err_Common } = common;
  const { Labels: Lbl_Personal_Info, SuccessMessages: Success_Personal_Info } = personalInformation;

  useEffect(() => {
    const fetch = async () => {
      setLoading(true);
      try {
        const { token, siteId, listId } = await getTokenAndListInfo(instance, listname);
        const found = await fetchItemById(token, siteId, listId, id!);
        setItem(found);
      }
      catch (error) {
        console.error("Error loading item", error);
      } finally {
        setLoading(false);
      }
    };
    fetch();
  }, [id]);

  if (loading)
    return <div className="loadercommon-container">
      <Spinner label={Success_Common.LOADER_MSG} size={SpinnerSize.large} />
    </div>;

  if (!item || item.length === 0)
    return <div className='no-records-container'>
      <Icon iconName="SearchData" className='no-records-icon' />
      <Text variant="large" style={{ color: "var(--color-black)" }}>
        {formatMessage(Err_Common.NOT_FOUND, "記録")}
      </Text>
    </div>
  const certificatePhotos: string[] = [
    "/images/file.jfif",
    "/images/katakana.png",
    "/images/sample.jfif",
    "/images/form1.jfif"
  ];
  const facePhotos: string[] = [
    "/images/form.jfif",
    "/images/sharepoint.png"
  ];
  return (
    <div className="background  list-background">
      <div className="form-container list-box">
        <div >
          <h2>{Lbl_Personal_Info.DETAILS}</h2>
          <Stack tokens={{ childrenGap: 10 }}>
            {[
              [Lbl_Personal_Info.NAME, item.Name],
              [Lbl_Personal_Info.DATEOFBIRTH, japaneseDateConverter(item.DateOfBirth)],
              [Lbl_Personal_Info.GENDER, item.Gender],
              [Lbl_Personal_Info.ADDRESS, item.Address],
              [Lbl_Personal_Info.PHONENUMBER, item.PhoneNumber ? phoneNumFormat(item.PhoneNumber) : ""],
              [Lbl_Personal_Info.EMERGENCY_PHONENUMBER_LBL, item.EmergencyPhone ? phoneNumFormat(item.EmergencyPhone) : ""],
              [Lbl_Personal_Info.EMERGENCY_NAME, item.EmergencyName],
              [Lbl_Personal_Info.EMERGENCY_RELATION, item.EmergencyRelation],
              [Lbl_Personal_Info.PARTNER_COMPANY, item.PartnerCompany],
              [Lbl_Personal_Info.IS_SOLE_PROPRIETOR, item.IsSoleProprietor],
              [Lbl_Personal_Info.SPECIAL_LABOR_INSURANCE, item.SpecialLaborInsurance],
              [Lbl_Personal_Info.BLOOD_TYPE, item.BloodType],
              [Lbl_Personal_Info.HEALTH_CHECK_DATE, japaneseDateConverter(item.HealthCheckDate)],
              [Lbl_Personal_Info.JOB_TYPE, item.JobType],
              [Lbl_Personal_Info.QUALIFICATIONS, item.Qualifications],
              [Lbl_Personal_Info.QUALIFICATION_EXPIRY, japaneseDateConverter(item.QualificationExpiry)],
              // [Lbl_Personal_Info.QUALIFICATION_PHOTO_LBL, item.CertificatePhotos],
              // [Lbl_Personal_Info.FACE_PHOTOS_LBL, item.FacePhotos],
            ].map(([label, value]) => (
              <Stack horizontal tokens={{ childrenGap: 10 }} key={label}>
                <Text className="label-text">
                  {label}:
                </Text>
                <Text className="value-text">
                  {value || "-"}
                </Text>
              </Stack>
            ))}
            <Stack tokens={{ childrenGap: 5 }}>
              <Text className="label-text">{Lbl_Personal_Info.QUALIFICATION_PHOTO_LBL}</Text>
              <Stack horizontal wrap tokens={{ childrenGap: 10 }}>
                {Array.isArray(certificatePhotos) ? (
                  certificatePhotos.map((url: string, i: number) => (
                    <a key={i} href={url} target="_blank" rel="noopener noreferrer">
                      <Image
                        src={url}
                        alt={`Certificate ${i + 1}`}
                        width={100}
                        height={80}
                        imageFit={ImageFit.cover}
                        styles={{
                          root: { border: "1px solid #ddd", borderRadius: 4 },
                        }}
                      />
                    </a>
                  ))
                ) : certificatePhotos ? (
                  <a href={certificatePhotos} target="_blank" rel="noopener noreferrer">
                    <Image
                      src={certificatePhotos}
                      alt="Certificate"
                      width={100}
                      height={80}
                      imageFit={ImageFit.cover}
                      styles={{
                        root: { border: "1px solid #ddd", borderRadius: 4 },
                      }}
                    />
                  </a>
                ) : (
                  <Text className="value-text">{Success_Personal_Info.NO_IMAGE_SELECTED}</Text>
                )}
              </Stack>
            </Stack>
            <Stack tokens={{ childrenGap: 5 }} style={{ marginTop: 16 }}>
              <Text className="label-text">{Lbl_Personal_Info.FACE_PHOTOS_LBL}</Text>
              <Stack horizontal wrap tokens={{ childrenGap: 10 }}>
                {Array.isArray(facePhotos) ? (
                  facePhotos.map((url: string, i: number) => (
                    <a key={i} href={url} target="_blank" rel="noopener noreferrer">
                      <Image
                        src={url}
                        alt={`Face ${i + 1}`}
                        width={100}
                        height={80}
                        imageFit={ImageFit.cover}
                        styles={{
                          root: { border: "1px solid #ddd", borderRadius: 4 },
                        }}
                      />
                    </a>
                  ))
                ) : facePhotos ? (
                  <a href={facePhotos} target="_blank" rel="noopener noreferrer">
                    <Image
                      src={facePhotos}
                      alt="Face"
                      width={100}
                      height={80}
                      imageFit={ImageFit.cover}
                      styles={{
                        root: { border: "1px solid #ddd", borderRadius: 4 },
                      }}
                    />
                  </a>
                ) : (
                  <Text className="value-text">{Success_Personal_Info.NO_IMAGE_SELECTED}</Text>
                )}
              </Stack>
            </Stack>
            <Stack horizontal className="buttonallign" tokens={{ childrenGap: 10 }}>
              <PrimaryButton className="custom-primary-button" text={Lbl_Common.EDIT} onClick={() => navigate(`/edit/${item.id}`)} />
              <PrimaryButton className="cancel-button" text={Lbl_Common.CLOSE} onClick={goBack} />
            </Stack>
          </Stack>
        </div>
      </div>
    </div>
  );
}